module.exports = __webpack_public_path__ + "img/icon_set_1.cd76faae.svg";